export default __webpack_public_path__ + "static/media/logo.acdda07a.svg";